module.exports = __webpack_public_path__ + "media/images/emblems/Mesocco_wappen-04ed1b250cec009f5d880bd4c15050fb.svg";